var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "approved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4tuafW.tif",
    "data-name": "4tuafW.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.13,8.64a1.25,1.25,0,0,1,.22,1,1.94,1.94,0,0,1-.45.79.2.2,0,0,0,0,.23,1.51,1.51,0,0,1,.12.84,1.67,1.67,0,0,1-.39.73.6.6,0,0,0-.14.66.89.89,0,0,1-.22.93,2.18,2.18,0,0,1-1.17.7c-.6.13-1.21.24-1.82.35-.31.06-.64.08-1,.12H8.55c-.27,0-.56-.07-.83-.13-.64-.15-1.27-.33-1.9-.46-.44-.09-.89-.13-1.33-.19a.22.22,0,0,0-.14.06.94.94,0,0,1-.72.31H1.56a.93.93,0,0,1-.95-.95V8.22a.93.93,0,0,1,.93-1H3.67a1,1,0,0,1,.63.25,1.85,1.85,0,0,0,.62-.71c.2-.43.39-.87.55-1.31a3.71,3.71,0,0,1,.79-1.29c.18-.18.35-.38.54-.54a3,3,0,0,0,1-1.75c.06-.28.11-.57.15-.86A1.16,1.16,0,0,1,8.82,0H9.2a1.8,1.8,0,0,1,1.11,1.16,4.43,4.43,0,0,1,.25.88,2.72,2.72,0,0,1-.41,2.09c-.2.29-.37.6-.55.91a2.94,2.94,0,0,0-.16.31,1.12,1.12,0,0,0,.27.1h.51l2.28.06a1.77,1.77,0,0,1,1.41.68,1.5,1.5,0,0,1,.21,2A.42.42,0,0,0,14.13,8.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.0d067050cc90b6766d4fe6fd9ad86e5b.svg";
export { ForwardRef as ReactComponent };